import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronDown } from 'react-icons/fi';
import '../styles/Pages.css';
import EnhancedHeader from '../components/EnhancedHeader';

const FAQs = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
  };

  const faqs = [
    {
      category: 'General Questions',
      items: [
        { q: 'What age group do you serve?', a: 'We provide services for vulnerable adults aged 18-65 years. Our supported residential accommodation is designed for individuals seeking to live independently with professional support and care.' },
        { q: 'How do I make a referral?', a: 'Referrals can be made through local authorities, social services, hospitals, and A/E wards. Please use our contact form or reach out directly to discuss the placement process.' },
        { q: 'What is the fee structure?', a: 'Our revenue model primarily comes from local authority placements with weekly fees ranging from £2500-5000 per resident, depending on their needs and services provided.' },
        { q: 'Are you regulated and compliant with UK standards?', a: 'Yes. Registration Number: 14464980. We provide outstanding care that meets UK regulatory standards. All staff are trained on safeguarding, behavior management, and trauma informed care.' }
      ]
    },
    {
      category: 'Services & Support',
      items: [
        { q: 'What types of support do you provide?', a: 'We offer comprehensive support including behavioral management, life skills training, mental health services, educational support, employment opportunities, and 24/7 safeguarding.' },
        { q: 'Do you support individuals with forensic backgrounds?', a: 'Yes. We provide specialized support for individuals with various backgrounds, including those with safeguarding concerns, forensic issues, and addiction histories.' },
        { q: 'Are mental health services available?', a: 'Yes. We provide access to professional therapists and mental health services, along with crisis needs interventions and trauma informed care.' },
        { q: 'Do you have staff available 24/7?', a: 'Yes. We have awaking night staff workers with access to professional therapists and counsellors to provide round-the-clock support.' }
      ]
    },
    {
      category: 'Locations & Accessibility',
      items: [
        { q: 'Where are your locations?', a: 'We currently operate in East Ham with access to local amenities and community resources. We are expanding to Croydon (coming soon).' },
        { q: 'Are the homes accessible?', a: 'Yes. Our residential homes are located in residential areas with access to amenities and community resources, ensuring community integration and accessibility.' }
      ]
    }
  ];

  return (
    <div className="page-container">
      <EnhancedHeader
        title="Frequently Asked Questions"
        subtitle="Find answers to your questions"
        backgroundImage="/images/residential-care-banner.jpg"
        backgroundGradient="linear-gradient(135deg, rgba(52, 152, 219, 0.7) 0%, rgba(41, 128, 185, 0.7) 100%)"
      />


      <motion.section
        className="faqs-section"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <div className="container">
          {faqs.map((category, catIdx) => (
            <motion.div key={catIdx} className="faq-category" variants={itemVariants}>
              <h2 className="faq-category-title">{category.category}</h2>

              <div className="faq-list">
                {category.items.map((faq, idx) => (
                  <motion.div
                    key={idx}
                    className={`faq-item ${expandedIndex === `${catIdx}-${idx}` ? 'expanded' : ''}`}
                    variants={itemVariants}
                    whileHover={{ boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)' }}
                  >
                    <motion.button
                      className="faq-question"
                      onClick={() =>
                        setExpandedIndex(
                          expandedIndex === `${catIdx}-${idx}` ? null : `${catIdx}-${idx}`
                        )
                      }
                      whileTap={{ scale: 0.98 }}
                    >
                      <span>{faq.q}</span>
                      <motion.div
                        animate={{
                          rotate: expandedIndex === `${catIdx}-${idx}` ? 180 : 0
                        }}
                        transition={{ duration: 0.3 }}
                      >
                        <FiChevronDown />
                      </motion.div>
                    </motion.button>

                    <AnimatePresence>
                      {expandedIndex === `${catIdx}-${idx}` && (
                        <motion.div
                          className="faq-answer"
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: 'auto' }}
                          exit={{ opacity: 0, height: 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          {faq.a}
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}

          {/* Image Placements */}
          <motion.div
            className="faq-images-section"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="faq-images-grid">
              <div className="faq-image">
                {/* IMAGE PLACEMENT 1: FAQ Topic */}
                <img src="/images/acr22.jpg" alt="FAQs" />
                
              </div>
              <div className="faq-image">
                {/* IMAGE PLACEMENT 2: Support/Help */}
                <img src="/images/acr20.jpg" alt="Support" />
              </div>
            </div>
          </motion.div>
        </div>
      </motion.section>
    </div>
  );
};

export default FAQs;
